module.exports = __webpack_public_path__ + "static/media/logo.edd34e09.svg";